import { ConfirmedTransactionStatus } from '@vestwell-sub-accounting/models/common/ConfirmedTransactionStatus';

export const ConfirmedTransactionStatusColorMap: Partial<
  Record<ConfirmedTransactionStatus, 'info' | 'success'>
> = {
  CONFIRMED: 'success',
  REVERSED: 'info'
};
